export class Validation {
    blockIds: number[];
    breakOverflowIds: number[];
    dateShift: string;
    motif: string;
  hrbp: string;
  agent: string;

  constructor(blockIds, breakOverflowIds, dateShift, motif?, dirSite?, agent?) {
    this.blockIds = blockIds;
    this.breakOverflowIds = breakOverflowIds;
    this.dateShift = dateShift;
    motif ? this.motif = motif : '';
    dirSite ? this.hrbp = dirSite : '';
    agent ? this.agent = agent : '';

  }
}



// WEBPACK FOOTER //
// ./src/app/model/validation.ts